<script>
import {
  utilizationStatus,
  Movement,
  deliveryTypes,
  orderType,
  orderTypes,
  movementType as movementListType,
  movementText as movementTypes,
} from "pando-constants";
const OrderMixins = {
  data() {
    return {
      utilizationStatus,
      Movement,
      deliveryTypes,
      orderType,
      orderTypes,
      movementListType,
      movementTypes,
    };
  },
  computed: {
    trackingEnabled() {
      return (
        this.order.flow && this.order.flow.sim_tracking && this.order.flow.sim_tracking.is_enabled
      );
    },
    showUtilization() {
      if (
        this.getPtlOrFtl !== this.deliveryTypes.FTL &&
        this.order.order_type === this.orderType.NO_FREIGHT
      ) {
        return false;
      }
      if (this.$hasPermission("view_vehicle_utilization")) {
        if (
          [
            this.utilizationStatus.PENDING,
            this.utilizationStatus.REJECTED
          ].includes(this.order.approval_status)
        ) {
          return (
            this.$hasPermission("request_vehicle_utilization") ||
            this.$hasPermission("update_vehicle_utilization")
          );
        } else if (
          [this.utilizationStatus.PROCESSING].includes(
            this.order.approval_status
          )
        ) {
          return this.$hasPermission("approve_vehicle_utilization");
        }
      }
      return false;
    },
    getSvgClassMovement() {
      if (this.order.movement === this.movementTypes.RETURNS) {
        return "status_return";
      } else if (this.order.movement === this.movementTypes.INWARD) {
        return "status_vendor";
      } else if (this.order.movement === this.movementTypes.PRIMARY) {
        return "primary";
      }
      return "secondary";
    },
    getSvgClassIndent() {
      const orderType = this.orderTypes.find(
        val => val.id === this.order.order_type
      );
      return orderType && orderType.iconName;
    },
    isPTLOrder() {
      return (
        this.order.vehicle_type &&
        this.order.vehicle_type.type == this.deliveryTypes.PTL
      );
    },
    getPtlOrFtl() {
      if (
        this.order.vehicle_type &&
        this.order.vehicle_type.type == this.deliveryTypes.PTL
      ) {
        return "PTL";
      }
      return "FTL";
    },
    getOrderType() {
      const orderType = this.orderTypes.find(
        val => val.id === this.order.order_type
      );
      return orderType && orderType.label;
    },
    getMovement() {
      if (this.order.movement === this.movementTypes.RETURNS) {
        return "Return";
      } else if (this.order.movement === this.movementTypes.INWARD) {
        return "Vendor";
      } else if (this.order.movement === this.movementTypes.PRIMARY) {
        return "Primary";
      }
      return "Secondary";
    }
  },
  methods: {
    statusName(id) {
      const mainStatus = this.$statusUtil.mainStatus;
      const mainStatusId = this.$statusUtil.getMainStatusId(id);
      return mainStatus.find(status => status.id === mainStatusId).label;
    }
  }
};
export default OrderMixins;
</script>
